import { createFileRoute } from '@tanstack/react-router'
import SmartView from '@/components/settings-route/ticket/view'

export const Route = createFileRoute('/_auth/settings/tickets/view')({
  component: SmartView,
})
